



























import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Nullable } from "@/general/custom-types/CustomTypes";

@Component
export default class ExpansionPanel extends Vue {
  @Prop({ default: true, type: Boolean }) readonly: Nullable<boolean>;
  @Prop({ default: false, type: Boolean }) scrollable: Nullable<boolean>;
  @Prop({ default: undefined }) elevation: Nullable<number> | Nullable<string>;

  switch: boolean = false;

  created() {
    if (!this.readonly) {
      this.switch = true;
    }
  }

  click(): void {
    this.switch = !this.switch;
  }

  get contentStyle(): string {
    return this.scrollable ? "content-scrollable" : "content";
  }
}
